import { apiClient } from '../api/client';

export type CreditTransactionType = 'added' | 'used' | 'refunded';

export interface CreditTransaction {
  id: string;
  playerId: string;
  amount: number;
  type: CreditTransactionType;
  description: string;
  addedByUserId?: string;
  createdAt: string;
}

export interface GetCreditHistoryResponse {
  transactions: CreditTransaction[];
}

class CreditService {
  /**
   * Get credit history for the authenticated player
   */
  async getCreditHistory(storeId: string): Promise<CreditTransaction[]> {
    try {
      const response = await apiClient.get<GetCreditHistoryResponse>(
        `/public/stores/${storeId}/credits`
      );
      return response.transactions;
    } catch {
      return [];
    }
  }

  /**
   * Add a CREDIT item to the player cart for the given amount (reais).
   * Server validates min/max and feature flag.
   */
  async addCreditToCart(storeId: string, amount: number): Promise<void> {
    await apiClient.post(`/public/stores/${storeId}/cart/credits`, { amount });
  }
}

export const creditService = new CreditService();
